import React from 'react';
import { Box, SkeletonText } from '@leagueplatform/genesis-core';

export interface SkeletonLoadingGroupProps {
  /** Number of skeleton rows to render */
  numberOfRows?: number;
  /** Whether to render skeleton text with header styling */
  header?: boolean;
  /** Bottom margin for each skeleton row */
  marginBottom?: 'half' | 'one';
  /** Test ID for the skeleton group */
  testId?: string;
}

/**
 * Shared skeleton loading component for table-like loading states.
 * Renders multiple SkeletonText components with consistent spacing and styling.
 */
export const SkeletonLoadingGroup: React.FC<SkeletonLoadingGroupProps> = ({
  numberOfRows = 3,
  header = false,
  marginBottom = 'one',
  testId = 'SkeletonLoadingGroup',
}) => {
  const baseId = React.useId();

  return (
    <Box data-testid={testId}>
      {Array.from({ length: numberOfRows }, (_, index) => (
        <SkeletonText
          header={header}
          css={{ marginBlockEnd: `$${marginBottom}` }}
          key={`${baseId}-skeleton-${index}`}
        />
      ))}
    </Box>
  );
};
